import { MeasurementPointIdStatuses } from '@core/enums/measurement-point-id-statuses';
import { SurveyMeasurementStatuses } from '@core/enums/survey-measurement-statuses';
import { AlarmConfig } from '@core/interfaces/alarm-config';
import { SurveyPoint } from '@core/interfaces/survey-point';

export class MeasurementHelper {
  public static isMeasurementInAlarmState(measurement: number, previousMeasurement: number, alarmConfig: AlarmConfig): boolean {
    if (measurement === 0 || !alarmConfig || !alarmConfig?.enableAlarm || previousMeasurement === 0) {
      return false;
    } else if (alarmConfig?.alarmType === 'Percentage') {
      const allowedMin: number = (previousMeasurement * (100 - alarmConfig.alarmLow)) / 100;
      const allowedMax: number = (previousMeasurement * (100 + alarmConfig.alarmHigh)) / 100;
      return allowedMin > measurement || allowedMax < measurement;
    } else if (alarmConfig?.alarmType === 'Numerical') {
      const allowedMin: number = previousMeasurement - alarmConfig.alarmLow;
      const allowedMax: number = previousMeasurement + alarmConfig.alarmHigh;
      return allowedMin > measurement || allowedMax < measurement;
    } else {
      return false;
    }
  }

  public static setMeasurementStatus(surveyPoint: SurveyPoint, alarmConfig: AlarmConfig): void {
    let countOfCompletedMeasurements = 0;
    let countOfCompletedMeasurementsWhenCommentIsEmpty = 0;
    let countOfCompletedWithAlarm = 0;
    (surveyPoint.ids ?? []).forEach(id => {
      const alarmState = MeasurementHelper.isMeasurementInAlarmState(id.measurement, id.previousMeasurement, alarmConfig);
      if ((id.status === MeasurementPointIdStatuses.Skipped || alarmState) && (id.comment === '' || id.comment === null)) {
        if (id.measurement !== undefined && id.measurement !== 0.0) {
          countOfCompletedMeasurementsWhenCommentIsEmpty++;
        }
        if (
          alarmState &&
          id.status !== MeasurementPointIdStatuses.CompleteWithAlarm &&
          id.measurement !== undefined &&
          id.measurement !== 0.0
        ) {
          countOfCompletedWithAlarm++;
          id.status = MeasurementPointIdStatuses.CompleteWithAlarm;
        } else if (!alarmState && id.measurement !== undefined && id.measurement !== 0.0) {
          id.status = MeasurementPointIdStatuses.Complete;
        }
      } else if (id.status === MeasurementPointIdStatuses.Skipped && (id.comment !== '' || id.comment !== null)) {
        countOfCompletedMeasurements++;
        if (alarmState && id.measurement !== undefined && id.measurement !== 0.0) {
          countOfCompletedWithAlarm++;
          id.status = MeasurementPointIdStatuses.CompleteWithAlarm;
        } else if (!alarmState && id.measurement !== undefined && id.measurement !== 0.0) {
          id.status = MeasurementPointIdStatuses.Complete;
        }
      } else if (
        id.status !== MeasurementPointIdStatuses.Skipped &&
        (id.comment !== '' || id.comment !== null) &&
        id.measurement !== undefined &&
        id.measurement !== 0.0
      ) {
        countOfCompletedMeasurements++;
        if (alarmState) {
          countOfCompletedWithAlarm++;
          id.status = MeasurementPointIdStatuses.CompleteWithAlarm;
        } else {
          id.status = MeasurementPointIdStatuses.Complete;
        }
      } else {
        id.status = MeasurementPointIdStatuses.Pending;
      }
    });
    if (!surveyPoint.ids || surveyPoint.ids.length === 0) {
      surveyPoint.measurementStatus = SurveyMeasurementStatuses.Pending;
    } else if (countOfCompletedMeasurements === surveyPoint.ids.length) {
      if (countOfCompletedWithAlarm > 0) {
        surveyPoint.measurementStatus = SurveyMeasurementStatuses.CompleteWithAlarm;
      } else {
        surveyPoint.measurementStatus = SurveyMeasurementStatuses.Complete;
      }
    } else if (countOfCompletedMeasurements > 0 || countOfCompletedMeasurementsWhenCommentIsEmpty > 0) {
      surveyPoint.measurementStatus = SurveyMeasurementStatuses.InProgress;
    } else {
      surveyPoint.measurementStatus = SurveyMeasurementStatuses.Pending;
    }
  }
}
